export default __webpack_public_path__ + "static/media/dashboard-innova-logo.cd644624.png";